import React from "react";
import useDepartmentDoctors from "../hooks/useDepartmentDoctors";
import DoctorCard from "./DoctorCard";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Phone, Mail, MapPin, Stethoscope, Activity, Users, Award, Clock,ArrowRight } from "lucide-react";
import SEO from "../pages/SEO"
import { useAppointment } from "../context/AppointmentContext"
function ENTPage() {
  const { open: openAppointment } = useAppointment();
  const doctors = useDepartmentDoctors("ENT");

  const subspecialties = [
    {
      title: "Otology",
      description: "Treatment for ear infections, hearing loss, tinnitus, and balance disorders.",
      image: "/Otology1.jpeg",
    },
    {
      title: "Rhinology",
      description: "Expertise in sinusitis, nasal polyps, and endoscopic sinus surgeries.",
      image: "/Rhinology1.jpeg",
    },
    {
      title: "Laryngology",
      description: "Voice, throat, and swallowing disorder management.",
      image: "/Laryngology1.jpeg",
    },
    {
      title: "Pediatric ENT",
      description: "Specialized care for children with tonsillitis, ear infections, and adenoid problems.",
      image: "/PediatricENT.jpg",
    },
    {
      title: "Head & Neck Surgery",
      description: "Advanced surgical care for tumors and structural abnormalities.",
      image: "/Head&NeckSurgery.jpg",
    },
    {
      title: "Allergy & Sinus Care",
      description: "Relief from chronic nasal allergies and sinusitis.",
      image: "/Allergy&SinusCare.jpg",
    },
  ];
  const treatments = [
    { name: "Endoscopic Sinus Surgery (FESS)", icon: Activity },
    { name: "Tympanoplasty & Mastoidectomy", icon: Stethoscope },
    { name: "Septoplasty & Turbinate Reduction", icon: Activity },
    { name: "Tonsillectomy & Adenoidectomy", icon: Stethoscope },
    { name: "Voice Therapy & Laryngoscopy", icon: Activity },
    { name: "Hearing Tests & Cochlear Implant Evaluation", icon: Stethoscope },
  ];
  const whyChoose = [
    { title: "ENT Specialists with Surgical Excellence", icon: Award },
    { title: "Endoscopic & Minimally Invasive Procedures", icon: Activity },
    { title: "Advanced Hearing & Balance Diagnostics", icon: Stethoscope },
    { title: "Comprehensive Pediatric ENT Care", icon: Users },
    { title: "Accessible Location near Miyapur & Bachupally", icon: MapPin },
  ];
  const articles = [
    { title: "Top Causes of Sinus Infections and How to Prevent Them", emoji: "👃" },
    { title: "When to Visit an ENT Specialist for Hearing Issues", emoji: "👂" },
    { title: "Voice Care Tips for Professionals", emoji: "🗣️" },
    { title: "Managing Seasonal Allergies Effectively", emoji: "🌸" },
  ];
  const faqs = [
    {
      question: "Do you perform endoscopic sinus surgery?",
      answer: "Yes, our ENT department is equipped for advanced endoscopic sinus and nasal surgeries.",
    },
    {
      question: "Is hearing loss reversible?",
      answer: "Depending on the cause, medical or surgical treatment can improve hearing in many cases.",
    },
    {
      question: "Do you offer pediatric ENT services?",
      answer: "Yes, we provide complete ENT care for children including tonsil and adenoid surgeries.",
    },
  ];
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "MAMS Hospitals ENT Department",
    "url": "https://mamshospitals.com/ent",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "image": "https://mamshospitals.com/ENT.jpg",
    "description": "MAMS Hospitals provides advanced ENT treatment in Hyderabad including sinus surgery, hearing loss treatment, tonsil surgery, allergy care, pediatric ENT services, and voice disorder treatment.",
    "medicalSpecialty": "Otolaryngology",
    "telephone": "+91-7399999981",
    "priceRange": "$$",

    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },

    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Endoscopic Sinus Surgery (FESS)"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Tonsillectomy & Adenoidectomy"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Hearing Tests & Cochlear Implant Evaluation"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Septoplasty & Turbinate Reduction"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Voice Therapy & Laryngoscopy"
      }
    ],

    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you perform endoscopic sinus surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals performs advanced endoscopic sinus surgeries and minimally invasive ENT procedures."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide treatment for hearing loss?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we provide hearing tests, hearing loss evaluation, cochlear implant assessment, and medical and surgical hearing treatments."
        }
      },
      {
        "@type": "Question",
        "name": "Do you offer pediatric ENT services?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals provides specialized pediatric ENT care for tonsils, adenoids, ear infections, and sinus conditions."
        }
      }
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "ENT Department - MAMS Hospitals",
    "url": "https://mamshospitals.com/ent",
    "description": "Best ENT hospital in Hyderabad offering sinus surgery, hearing loss treatment, pediatric ENT care, allergy treatment, voice therapy, and minimally invasive ENT procedures.",
    "keywords": [
      "Best ENT Specialist Hyderabad",
      "ENT Hospital Hyderabad",
      "Sinus Surgery Hyderabad",
      "Hearing Loss Treatment Hyderabad",
      "Tonsil Surgery Hyderabad",
      "Pediatric ENT Hyderabad",
      "ENT Hospital Bachupally"
    ]
  }
];

  return (
    <>
    <SEO
      title="Best ENT Hospital in Hyderabad | Ear Nose Throat Specialists | MAMS Hospitals"
      description="MAMS Hospitals offers advanced ENT treatment in Hyderabad including sinus surgery, hearing loss treatment, pediatric ENT care, allergy treatment, tonsil surgery, and voice therapy."
      keywords="best ENT specialist Hyderabad,
    ENT hospital Hyderabad,
    sinus surgery Hyderabad,
    hearing loss treatment Hyderabad,
    tonsil surgery Hyderabad,
    pediatric ENT Hyderabad,
    voice therapy Hyderabad,
    septoplasty Hyderabad,
    FESS surgery Hyderabad,
    allergy treatment Hyderabad,
    ear specialist Hyderabad,
    ENT hospital Bachupally,
    MAMS Hospitals ENT"
      schema={schema}
      canonicalUrl="https://mamshospitals.com/departments/ent"
    />
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-primary/10 via-primary/5 to-white py-12 md:py-24">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-semibold mb-4">
                Best ENT Hospital in Hyderabad
              </div>
              <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
                Your Trusted Partner for Complete ENT Wellness
              </h1>
              <p className="text-lg text-gray-700 mb-8">
                At MAMS Hospitals, we take pride in being one of the Best ENT Hospitals in Hyderabad, offering advanced
                treatments for ear, nose, and throat disorders. Our ENT specialists use cutting-edge diagnostic tools
                and minimally invasive surgical techniques to restore comfort and hearing clarity.
              </p>

             <div className="flex flex-col sm:flex-row gap-4">

                <Button className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-8" size="lg" onClick={openAppointment}>
                    Book Appointment
                  </Button>

                <Link to="tel:+91-7399999981">
                  <Button
                    className="border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full px-8"
                    variant="outline"
                    size="lg"
                  >
                    <Phone className="mr-2 h-5 w-5" />
                    Call Us
                  </Button>
                </Link>

              </div>

              {/* <p className="text-sm text-gray-600 italic">
                From sinus care to voice restoration — MAMS Hospitals is your trusted partner for complete ENT wellness.
              </p> */}
            </div>

            <div className="relative mt-8 md:mt-0 h-[300px] md:h-[400px] rounded-xl overflow-hidden shadow-2xl">
              <img src="/ENT.jpg" alt="ENT Specialist" className="object-cover w-full h-full" />
            </div>
          </div>
        </div>
      </section>

      {/* Sub-Specialties */}
      <section className="py-16 px-0 bg-slate-50">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Sub-Specialties in ENT</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Comprehensive ENT care covering all aspects of ear, nose, and throat health
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {subspecialties.map((s, i) => (
              <Card key={i} className="overflow-hidden hover:shadow-lg transition-all">
                <div className="relative h-48">
                  <img src={s.image} alt={s.title} className="object-cover w-full h-full" />
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{s.title}</h3>
                  <p className="text-gray-600">{s.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Treatments */}
      <section className="py-16 px-0">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Treatments & Procedures</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Advanced surgical and non-surgical treatments for ENT conditions
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {treatments.map((item, index) => {
              const Icon = item.icon;
              return (
                <Card key={index} className="p-6 hover:shadow-lg transition-all border-l-4 border-l-primary">
                  <div className="flex items-start gap-4">
                    <div className="bg-primary/10 p-3 rounded-lg">
                      <Icon className="h-6 w-6 text-primary" />
                    </div>
                    <h3 className="font-semibold text-gray-900">{item.name}</h3>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why Choose */}
      <section className="py-16 px-0 bg-primary/5">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose MAMS Hospitals for ENT Care
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyChoose.map((item, i) => {
              const Icon = item.icon;
              return (
                <Card key={i} className="p-6 text-center hover:shadow-lg transition-all">
                  <div className="flex justify-center mb-4">
                    <div className="bg-primary/10 p-4 rounded-full">
                      <Icon className="h-8 w-8 text-primary" />
                    </div>
                  </div>
                  <h3 className="font-semibold text-gray-900">{item.title}</h3>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Specialist */}
                      {doctors.length > 0 && (
          <section className="py-16 px-0 bg-apple-gray-50">
            <div className="container mx-auto max-w-6xl">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">Meet Our Specialists</h2>
              </div>
              <div className="relative">
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: -340, behavior: 'smooth' }); }}
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <div id="doc-scroll" className="flex gap-6 overflow-x-auto scroll-smooth px-10 scrollbar-hide pb-4">
                  {doctors.map(doctor => (
                    <div key={doctor.id} className="w-[280px] sm:w-[300px] flex-shrink-0">
                      <DoctorCard doctor={{
                        name: doctor.title.rendered,
                        slug: doctor.slug,
                        imageUrl: doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
                        specialty: doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "",
                        designation: doctor.acf?.designation || "",
                        qualification: doctor.acf?.qualification || "",
                        experience: doctor.acf?.experience || "",
                      }} />
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: 340, behavior: 'smooth' }); }}
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </button>
              </div>
              <div className="text-center mt-8">
                <Link to="/doctors">
                  <button className="px-6 py-3 rounded-full border text-sm font-medium inline-flex items-center gap-2">
                    View All Doctors
                  </button>
                </Link>
              </div>
            </div>
          </section>
          )}


      {/* Articles */}
      {/* <section className="py-16 px-0 bg-slate-50">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Recent Articles</h2>
            <p className="text-gray-600">Stay informed with our latest health tips and insights</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {articles.map((article, index) => (
              <Card key={index} className="p-6 hover:shadow-lg transition-all cursor-pointer">
                <div className="flex items-start gap-4">
                  <div className="text-4xl">{article.emoji}</div>
                  <h3 className="font-semibold text-gray-900 hover:text-primary transition">{article.title}</h3>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section> */}

      {/* FAQs */}
      <section className="py-16 px-0">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          </div>

          <div className="space-y-6">
            {faqs.map((faq, i) => (
              <Card key={i} className="p-6">
                <h3 className="font-bold text-gray-900 mb-3 text-lg">{faq.question}</h3>
                <p className="text-gray-700">{faq.answer}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Contact & Appointment Section */}
      <section className="py-16 px-0 bg-apple-teal text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold mb-4">Book an Appointment</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Your heart health is our top priority. Book an appointment today with Hyderabad's trusted experts at MAMS Hospitals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Call Us</h3>
                <a href="tel:+917399999981" className="text-white/90 hover:text-white">
                  +91-7399999981
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Email Us</h3>
                <a href="mailto: info@mamshospitals.com" className="text-white/90 hover:text-white">
                   info@mamshospitals.com
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Visit Us</h3>
                <p className="text-white/90">Bachupally, Miyapur</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            {/* <Link href="/book-appointment">
              <Button size="lg" variant="secondary" className="rounded-full">
                <Calendar className="mr-2 h-5 w-5" />
                Schedule Your Appointment
              </Button>
            </Link> */}
          </div>
        </div>
      </section>

      {/* Emergency Banner */}
      <section className="py-8 px-0 bg-red-600 text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <Clock className="h-8 w-8" />
              <div>
                <h3 className="text-xl font-bold">24/7 Emergency Care</h3>
                <p className="text-white/90">Fully equipped emergency department </p>
              </div>
            </div>
            <a href="tel:+917399999981">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto rounded-full bg-white text-red-600 hover:bg-gray-100">
                <Phone className="mr-2 h-5 w-5" />
                Call Emergency
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}

export default ENTPage;
